{
  "header": {
    "title": "Settings",
    "description": "Manage your preferences, notifications, and access settings to customize your Chirpee experience"
  },
  "tabs": {
    "workplace": {
      "title": "Workplace",
      "logo": "Workplace logo",
      "changeLogo": "Change logo",
      "logoEmptyState": "No logo uploaded yet",
      "logoValidation": {
        "invalidFormat": "Please choose a PNG, JPEG, GIF, or WebP image.",
        "fileTooLarge": "Image must be 5 MB or smaller.",
        "dimensionsTooLarge": "Image dimensions must be at most 4096 × 4096 pixels.",
        "loadFailed": "Could not read this image. Try another file."
      },
      "logoUploadErrorFallback": "Could not upload the logo. Please try again.",
      "maxSize": "Max. 5 MB · max. 4096 × 4096 px",
      "format": "PNG, JPEG, GIF, or WebP",
      "worplaceNameInput": {
        "label": "Workplace name",
        "placeholder": "Workplace name"
      },
      "companyIndustryInput": {
        "label": "Company industry",
        "placeholder": "Company industry",
        "industries": {
          "technology": "Technology",
          "professionalServices": "Professional Services",
          "financialServices": "Financial Services",
          "consulting": "Consulting",
          "softwareDevelopment": "Software Development",
          "digitalMarketing": "Digital Marketing",
          "mediaAndCommunications": "Media and Communications",
          "eCommerce": "E-commerce",
          "healthTech": "Health Tech"
        }
      },
      "languguages": {
        "title": "Supported languages",
        "helpText": "Hept text"
      },
      "applyButton": "Apply changes"
    },
    "userManagement": {
      "title": "User Management",
      "userInput": {
        "placeholder": "Search users"
      },
      "roleDropdown": {
        "triggerLabel": "Role",
        "options": {
          "admin": "Administrator",
          "people_experience": "People Experience",
          "user": "User"
        }
      }
    },
    "integrations": {
      "title": "Integrations",
      "options": {
        "hris": { "label": "HRIS" },
        "sso": { "label": "Single Sign-On (SSO)" },
        "messagingConnected": { "label": "Communication Tool" }
      }
    },
    "billing": {
      "title": "Billing",
      "planSection": {
        "title": "Your plan",
        "status": {
          "active": "Active"
        },
        "usersCount": {
          "title": "Monthly users"
        },
        "amount": {
          "title": "Renewal amount",
          "cost": "per user"
        },
        "charge": {
          "title": "Next charge"
        },
        "cycle": {
          "title": "Billing cycle"
        }
      },
      "invoiceInformationSection": {
        "title": "Invoice Information",
        "name": "Company name",
        "email": "Billing email",
        "address": "Company address",
        "taxId": "Tax ID",
        "paymentMethod": "Payment method",
        "paymentDate": "Last payment date",
        "editButton": "Edit",
        "portalError": "Could not open the billing portal. Please try again."
      },
      "invoiceHistorySection": {
        "title": "Invoice History",
        "viewButton": "View",
        "downloadButton": "Download",
        "emptyState": {
          "title": "No invoices yet",
          "description": "Invoices will appear here after your first successful payment."
        }
      },
      "errorState": {
        "title": "Could not load billing details",
        "description": "Please refresh the page and try again."
      }
    },
    "logs": {
      "title": "Audit logs",
      "table": {
        "title": "Recent Activity",
        "acitivityDropdown": {
          "triggerLabel": "All activities"
        },
        "usersDropdown": {
          "triggerLabel": "All users"
        },
        "exportButton": "Export logs"
      }
    }
  },
  "columns": {
    "name": "Name",
    "department": "Department",
    "role": "Role",
    "active": "Last Active"
  },
  "settingsBillingInvoiceHistorySection": {
    "date": "Payment date",
    "status": "Status",
    "amount": "Amount",
    "actions": "",
    "view": "View",
    "download": "Download"
  },
  "settingsLogsActivitySection": {
    "date": "Payment date",
    "activity": "Activity",
    "user": "User"
  },
  "dateLabels": {
    "thisMonth": "This month",
    "lastMonth": "Last month",
    "monthsAgo": "{{count}} months ago"
  }
}
